import type { SormDataAccess } from './sorm-data-access'

// Private scopes skip TanStack's signal: reading it cancels the query when its last observer leaves.
export function sormRequestOptions(
  dataAccess: SormDataAccess,
  context: { readonly signal: AbortSignal },
): { readonly signal?: AbortSignal } {
  switch (dataAccess.scope.api) {
    case 'platform':
      return { signal: context.signal }
    case 'private':
      return {}
    default:
      return dataAccess.scope satisfies never
  }
}
